import { combineSlices } from "@reduxjs/toolkit";
import hostnamesSlice from "Data/Redux/Slices/Hostnames";
import userSlice from "Data/Redux/Slices/User";

export const rootReducer = combineSlices(hostnamesSlice, userSlice);

export type AppState = ReturnType<typeof rootReducer>;
